/**
 * @generated SignedSource<<5e8764ad67fa117f9f144c78b8b46646>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ContactInfoState = "DRAFT" | "VERIFIED";
export type ContactInfoType = "EMAIL" | "PHONE";
export type ContactInfoFieldRequestMutation$variables = {
  type: ContactInfoType;
  value: string;
};
export type ContactInfoFieldRequestMutation$data = {
  readonly requestContactInfoVerification: {
    readonly contactInfo: {
      readonly id: string;
      readonly state: ContactInfoState;
      readonly type: ContactInfoType;
      readonly value: string;
    };
  };
};
export type ContactInfoFieldRequestMutation = {
  response: ContactInfoFieldRequestMutation$data;
  variables: ContactInfoFieldRequestMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "type"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "value"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "type",
        "variableName": "type"
      },
      {
        "kind": "Variable",
        "name": "value",
        "variableName": "value"
      }
    ],
    "concreteType": "ContactInfoMutationResult",
    "kind": "LinkedField",
    "name": "requestContactInfoVerification",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ContactInfo",
        "kind": "LinkedField",
        "name": "contactInfo",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "type",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "value",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "state",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ContactInfoFieldRequestMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ContactInfoFieldRequestMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "7ea201684b61549128b9410d15ee4546",
    "id": null,
    "metadata": {},
    "name": "ContactInfoFieldRequestMutation",
    "operationKind": "mutation",
    "text": "mutation ContactInfoFieldRequestMutation(\n  $type: ContactInfoType!\n  $value: String!\n) {\n  requestContactInfoVerification(type: $type, value: $value) {\n    contactInfo {\n      id\n      type\n      value\n      state\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "d12916f105c5572fc7ebf9d6f3ad2118";

export default node;
